module.exports = __webpack_public_path__ + "static/media/autumnleafb.b7435496.webp";